import React from 'react';
import { styled } from '@compiled/react';
import { Card, CardAction } from '@atlaskit/smart-card';
import { SmartCardProviderMigration } from '@atlassian/jira-linking-platform-provider-migration/src/index.tsx';
import type { CmdbObjectAttributeDefault } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeDefault;
};

export const EmailAttribute = (props: { attribute: CmdbObjectAttributeDefault }) => {
	const { attribute } = props;

	return (
		<>
			{attribute.objectAttributeValues.map((value, index) => (
				<StyledAnchor target="_blank" key={index} href={`mailto:${value.displayValue}`}>
					{value.displayValue}
				</StyledAnchor>
			))}
		</>
	);
};

export const UrlAttribute = ({ attribute }: { attribute: CmdbObjectAttributeDefault }) => (
	<SmartCardProviderMigration>
		{attribute.objectAttributeValues.map((value, index) => {
			const href = value.displayValue;
			return (
				<Card
					key={index}
					url={href}
					appearance="inline"
					fallbackComponent={() => (
						<StyledAnchor target="_blank" key={index} href={href}>
							{value.displayValue}
						</StyledAnchor>
					)}
					actionOptions={{
						hide: false,
						exclude: [CardAction.ChangeStatusAction],
					}}
				/>
			);
		})}
	</SmartCardProviderMigration>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledAnchor = styled.a({
	display: 'block',
});
